<div class="container-fluid">
    <!-- Question Details -->
    <div class="row shadow p-2">
        <div class="col-12">
            <span class="font-size: 9pt"><small class="text-muted">Question Title:
                </small>{{data.question_title | uppercase}}</span><br />
            <span class="font-size: 9pt"><small class="text-muted">Question:
                </small>{{data.question | uppercase}}</span><br />
            <button class="back-btn btn-muted mt-2" mat-dialog-close><i class="icon-chevron-left"></i> Back to
                Questions</button>
        </div>
    </div>
    <!--  -->

    <!-- Spinner -->
    <div align="center" *ngIf="spinner" class="mt-3">
        <mat-spinner [diameter]="30"></mat-spinner>
    </div>
    <!--  -->

    <!-- Input for adding response -->
    <div class="row mx-auto w-100">
        <div class="col-9 col-md-10">
            <mat-form-field class="w-100" appearance="fill">
                <mat-label>Response</mat-label>
                <input matInput [(ngModel)]="response">
            </mat-form-field>
        </div>
        <div class="col-2">
            <button mat-raised-button color="primary" class="mt-3" (click)="addResponse()">Post</button>
        </div>
    </div>
    <!--  -->

    <!-- Empty Response -->
    <div *ngIf="emptyResponse">
        <p class="text-center">
            No Response in this course yet! Kindly add your response.
        </p>
    </div>
    <!--  -->

    <!-- Displaying all responses -->
    <div class="" style="height: 55vh; max-height: 57vh; overflow: auto;">
        <div class="row shadow card border m-2 mt-3 p-2" *ngFor="let response of allResponses">
            <div class="col-12 mx-auto">
                <div class="row">
                    <div class="d-flex">
                        <div>
                            <mat-icon class="mr-3 mt-2" style="font-size: 25pt;">account_circle_full</mat-icon>
                        </div>
                        <div>
                            <span *ngIf="response.student_id">{{response.firstname}} {{response.lastname}}</span>
                            <span *ngIf="response.staff_id">{{response.staff_firstname}} {{response.staff_lastname}}
                                <span class="badge bg-light shadow-sm p-1 border text-muted">staff</span></span><br>
                            <span style="font-size: 8pt;">{{response.created_at}}</span>
                        </div>
                    </div>
                </div>
                <div class="mt-1">
                    <p>{{response.question}}</p>
                </div>
            </div>
        </div>
    </div>
    <!--  -->
</div>